// extracted by mini-css-extract-plugin
module.exports =  {"layout":"Layout-module__layout___svXmf","skip-links":"Layout-module__skip-links___q0qpa","header":"Layout-module__header___YR4Ag","footer":"Layout-module__footer___JeSOb"};